import React, { useState } from "react";
import { Modal } from "./Modal";
import { HeaderModal } from "./Header";
import { Body } from "./Body";
import { FooterModal } from "./Footer";
import allImgPaths from "assets/images";
import closeIcon from "assets/images/close-icon.svg";
import HistoryFileUpload from "components/history/HistoryFileUpload";
import { format } from "date-fns";

const ViewContentModal = ({ data: viewData, setShowViewModal, type }: any) => {
    const [data, setData] = useState<any>(viewData);

    const getFileExtension = (filename: any) => {
        const imageExts = ['png', 'jpg', 'jpeg'];
        const fileExtension = filename.split('.').pop()
        return imageExts.includes(fileExtension)
    }

    const formatDate = (dateStr: any) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const headerStyle: any = {
        padding: '0.75rem 1.5rem',
        textAlign: 'left',
        fontSize: '0.75rem',
        fontWeight: '500',
        color: '#6B7280',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
    };

    const cellStyle: any = {
        paddingLeft: '0.5rem',
        paddingRight: '0.5rem',
        paddingTop: '1rem',
        paddingBottom: '1rem',
        whiteSpace: 'nowrap',
    };

    const mainTableStyle: any = {
        overflowX: 'auto',
        overflowY: 'auto',
        border: '1px solid',
        borderStyle: 'solid',

    };

    const tableStyle: any = {
        minWidth: '100%',
        borderCollapse: 'collapse',
        borderBottom: '1px solid #E5E7EB'
    };

    const bodyStyle: any = {
        backgroundColor: '#FFFFFF',
        borderCollapse: 'collapse',
        borderBottom: '1px solid #E5E7EB'
    };

    return (
        <>
            <Modal className={"modal-wrapper max-w-[1200px] h-[600px]"} isShow={setShowViewModal}>
                <HeaderModal title={"test"} isShowHeader={true} className="modal-header py-4 px-4 border-b border-[#EAECF0]">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center justify-between ml-2.5 gap-x-3">
                            <img
                                className='w-[18px] h-[18px] rounded-full'
                                src={allImgPaths.iButtonIcon}
                                alt=''
                            />
                            <h2 className="text-lg text-[#101828] font-interBold leading-none">
                                {data?.title}
                            </h2>
                        </div>
                        {/* Close Icon */}
                        <img
                            className="modal-close modal-toggle cursor-pointer hover:bg-[#f2f4f7] rounded w-5 p-1"
                            id="modal-toggle"
                            src={closeIcon}
                            onClick={() => { setShowViewModal(false) }}
                            alt="close icon"
                        />
                    </div>

                </HeaderModal>

                <Body title="" isShowBody={true} className="px-6 pt-6">
                    <div className="rounded-lg pl-5 pr-5 pb-5 shadow-customShadow10 mb-3 bg-[#fff] ml-1 max-h-[450px] overflow-y-auto">
                        <div className={`text-sm font-interMedium text-[#4F4D55] no-css`}>
                            <>
                                {
                                    data.content.map((fd: any, index: number) => (
                                        <React.Fragment key={index}>
                                            <div>
                                                {
                                                    fd?.showLabel &&
                                                    <label>
                                                        <strong>{fd?.title}</strong>
                                                    </label>
                                                }
                                                {
                                                    (fd.type == 'text' || fd.type == 'number') &&
                                                    <>
                                                    <br />
                                                        {
                                                            fd.title != 'Social Links' &&
                                                            <div
                                                                suppressContentEditableWarning={true}
                                                                className={`pr-14 no-css mb-3`}
                                                                dangerouslySetInnerHTML={{ __html: fd?.content }}
                                                            >
                                                            </div>
                                                        }
                                                        {
                                                            fd.title == 'Social Links' &&

                                                            fd?.content?.length > 0 && fd.content.map((con: any, index: number) => (
                                                                <React.Fragment key={index}>
                                                                    <label>
                                                                        <strong>{con?.title}</strong>:
                                                                        <span className='ml-1.5'>{con?.value}</span>
                                                                    </label>
                                                                </React.Fragment>
                                                            ))
                                                        }
                                                    </>
                                                }
                                                {
                                                    (fd.type == 'table' && fd.hidden) &&
                                                    <>
                                                        {
                                                            fd?.content && fd?.content?.length > 0 &&
                                                            <div style={mainTableStyle}>
                                                                <table style={tableStyle}>
                                                                    <thead style={{ backgroundColor: '#F9FAFB' }}>
                                                                        <tr>
                                                                            {
                                                                                Object.keys(fd.content[0]).map((key: any, keyIndex: number) => (
                                                                                    <th
                                                                                        key={keyIndex}
                                                                                        scope="col"
                                                                                        style={headerStyle}
                                                                                    >
                                                                                        {key}
                                                                                    </th>
                                                                                ))
                                                                            }
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody style={bodyStyle}>
                                                                        {fd.content.map((value: any, vIndex: any) => (
                                                                            <tr key={vIndex}>
                                                                                <td style={cellStyle}>{typeof value.date === 'string' && value.date.includes('T') ? formatDate(value.date) : value.date}</td>
                                                                                <td style={cellStyle}>{value.location}</td>
                                                                                <td style={cellStyle}>{value.startTime}</td>
                                                                                <td style={cellStyle}>{value.endTime}</td>
                                                                                <td style={cellStyle}>{value.eventName}</td>
                                                                                <td style={cellStyle}>{value.description}</td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        }
                                                    </>
                                                }
                                                {
                                                    fd.type == 'multi' && fd?.htmlFor != 'ScheduleInfo' && fd?.content && Object.keys(fd.content).length > 0 &&

                                                    <div className='mt-5'>
                                                        {
                                                            Object.keys(fd.content).map((key: any, index: number) => (
                                                                <div key={index} style={{ marginBottom: '10px' }}>
                                                                    <label style={{ fontWeight: 'bold', marginRight: '5px', textTransform: 'capitalize' }}>{key}:</label>
                                                                    {
                                                                        key == 'date' &&
                                                                        <span>{format(fd.content[key], 'dd MMMM yyyy')}</span>
                                                                    }
                                                                    {
                                                                        // (key == 'photo' || key == 'logo') &&
                                                                        key == 'image' &&
                                                                        <div>
                                                                            {
                                                                                fd?.content?.[key]?.filename && getFileExtension(fd?.content?.[key]?.filename) &&
                                                                                <div>
                                                                                    <img
                                                                                        className="w-full h-full object-cover rounded border border-[#ddd]"
                                                                                        src={fd.content[key].imageUrl}
                                                                                        style={{ width: fd?.content[key]?.width || '60', height: fd?.content[key]?.height || 60 }}
                                                                                        alt=""
                                                                                    />
                                                                                </div>
                                                                            }
                                                                            {
                                                                                fd?.content?.[key].filename && !getFileExtension(fd?.content?.[key]?.filename) &&
                                                                                <div>
                                                                                    <HistoryFileUpload
                                                                                        fileName={fd?.content[key].filename}
                                                                                        fileSize={null}
                                                                                        contentType={'isRichTextContent'}
                                                                                    />
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    }
                                                                    {
                                                                        (key != 'date' && key != 'image') &&
                                                                        <span>{fd.content[key]}</span>
                                                                    }
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                }
                                                {
                                                    fd.type == 'image' && fd.name == 'RfpInnerLogo' && fd?.content?.imageUrl &&
                                                    <>
                                                        {
                                                            getFileExtension(fd.content.filename) &&
                                                            <div>
                                                                <img
                                                                    className="w-full h-full object-cover rounded border border-[#ddd]"
                                                                    src={fd.content.imageUrl}
                                                                    style={{ width: fd?.content?.width, height: fd?.content?.height }}
                                                                    alt=""
                                                                />
                                                            </div>
                                                        }
                                                        {
                                                            !getFileExtension(fd.content.filename) &&
                                                            <HistoryFileUpload
                                                                fileName={fd?.content?.filename}
                                                                fileSize={null}
                                                                contentType={'isRFP'}
                                                            />
                                                        }
                                                    </>
                                                }
                                                <br />
                                            </div>
                                        </React.Fragment>
                                    ))
                                }
                            </>
                        </div>
                    </div>
                </Body>

                <FooterModal title="" isShowFooter={true} className="modal-footer pt-2 px-6 pb-2">
                    <div className="flex justify-end items-center gap-x-2">
                        <div className="flex items-center gap-x-3 justify-center">
                            <button
                                type="button"
                                className="!text-base text-white bg-[#1E0AF5] hover:bg-[#120693] font-interSemiBold rounded-lg  px-3.5 py-2 flex-1"
                                onClick={() => { setShowViewModal(false) }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </FooterModal>
            </Modal >
        </>
    );
}

export default ViewContentModal;
